import { useSearchParams } from "next/navigation";
import { useRouter } from "next/router";

export const ImpactChainUtmSourceName = "impact_chain_source"; // remove utm from name to avoid creating a custom question
export const OldImpactChainUtmSourceName = "utm_impact_chain_source";

export const useFormQueryParams = () => {
  const searchParams = useSearchParams();
  const sessionId = searchParams.get("sessionId");
  const emailDeliveryId = searchParams.get("emailDeliveryId");
  const emailId = searchParams.get("emailId");
  const impactChainUtmSourceEmail =
    searchParams.get(ImpactChainUtmSourceName) || searchParams.get(OldImpactChainUtmSourceName);
  // eslint-disable-next-line @simplyk/zeffy-linter/avoid-router-query
  const { query } = useRouter();

  const { donationFormId, campaignId, ticketingId } = query as {
    donationFormId?: string;
    campaignId?: string;
    ticketingId?: string;
  };

  return {
    sessionId,
    emailDeliveryId,
    emailId,
    donationFormId,
    campaignId,
    ticketingId,
    impactChainUtmSourceEmail,
  };
};
